import { render, staticRenderFns } from "./GerenciarElementosItens.vue?vue&type=template&id=58ce533b&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarElementosItens.vue?vue&type=style&index=0&id=58ce533b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce533b",
  null
  
)

export default component.exports